import { render, staticRenderFns } from "./TaxComputationSheet.vue?vue&type=template&id=5f395f61"
import script from "./TaxComputationSheet.vue?vue&type=script&lang=js"
export * from "./TaxComputationSheet.vue?vue&type=script&lang=js"
import style0 from "./TaxComputationSheet.vue?vue&type=style&index=0&id=5f395f61&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports